var map = {
	"./example.svg": 49892,
	"./eye-close.svg": 25881,
	"./eye-open.svg": 14301,
	"./eye.svg": 34986,
	"./form.svg": 74062,
	"./password.svg": 46408,
	"./table.svg": 3797,
	"./tree.svg": 40964,
	"./user.svg": 30042
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87886;